import { useCallback, useRef } from 'react';

type PageType = 'evm' | 'mvx';

const prefetchedModules = new Set<string>();

export const usePrefetchPaymentRoots = () => {
  const fetchedPaymentPage = useRef(false);

  return useCallback((pageType: PageType) => {
    if (!fetchedPaymentPage.current) {
      fetchedPaymentPage.current = true;
      import('../../Payment/Payment');
    }

    if (pageType === 'mvx' && !prefetchedModules.has('mvx')) {
      prefetchedModules.add('mvx');
      import('../components/MvxPaymentRoot');
    }

    if (pageType === 'evm' && !prefetchedModules.has('evm')) {
      prefetchedModules.add('evm');
      import('../components/EVMPaymentRoot');
    }
  }, []);
};
